import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import React from 'react';

const useStyles = makeStyles({
  inputField: {
    '&&': {
      border: 'none',
      width: '100%',
    },

    '& input': {
      width: '100%',
      padding: '2px 10px',
      height: 40,
      border: 'none',
      outline: 'none',
      fontSize: '1rem',
    },

    '& div': {
      marginTop: 5,
      background: 'white',
      marginBottom: '1rem',
      borderRadius: 4,
      border: '1px solid #b5b5b5',
    },

    '& label': {
      transform: 'none !important',
      position: 'relative !important',
      height: '20px !important',
      alignSelf: 'flex-start !important',
      fontSize: '1rem !important',
      marginBottom: '0.5rem !important',
      fontWeight: 'normal !important',
      fontStyle: 'normal !important',
      fontStretch: 'normal !important',
      lineHeight: '1.62 !important',
      letterSpacing: 'normal !important',
      fontFamily: 'sans-serif !important',
    },

    '& div:before': {
      content: '',
      border: 'none !important',
      transition: 'none',
    },

    '& div:after': {
      content: '',
      transition: 'none',
      border: 'none !important',
    },
  },
  error: {
    '& div': {
      border: '1px solid #F44336 !important',
    },
    '& label': {
      color: '#F44336 !important',
    },
  },
});

const InputField = (props) => {
  const classes = useStyles();

  const { error } = props;
  return <TextField className={[classes.inputField, error ? classes.error : '']} {...props} />;
};

export default InputField;
